import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import titleize from 'titleize'
import Modal from 'react-modal'

import FullRow from './full_row'
import csrfToken from '../csrf_token'

const TIE_COLORS = {
  'No Cable Tie': null,
  'White (0)': 0,
  'Red (1)': 1,
  'Orange (2)': 2,
  'Yellow (3)': 3,
  'Dark Green (4)': 4,
  'Blue (5)': 5,
  'Gray (6)': 6,
  'Brown (7)': 7,
  'Purple (8)': 8,
  'Black (9)': 9
}

export default class BirdForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      bird: props.bird,
      showWarningModal: false
    }

    this.plumageVariation = this.plumageVariation.bind(this)
  }

  title() {
    const birdCount = this.props.survey.bird_count
    const birdPosition = this.state.bird.position
    const nextBirdNumber = birdCount + 1

    return this.props.newRecord ?
      `New Bird (${nextBirdNumber} of ${nextBirdNumber})` :
      `Bird ${birdPosition} of ${birdCount}`
  }

  formClasses() {
    classNames({
      "disabled": !this.props.isEditable
    })
  }

  applyTaxonomyChanges(changes, fieldName, value) {
    _.each(['', 'verifier_'], prefix => {
      if (fieldName === `${prefix}foot_type_family_id`) {
        changes[`${prefix}species_id`] = null
        changes[`${prefix}group_id`] = null
        changes[`${prefix}subgroup_id`] = null
      }

      if (fieldName === `${prefix}species_id`) {
        changes[`${prefix}group_id`] = null
        changes[`${prefix}subgroup_id`] = null
      }

      if (fieldName === `${prefix}group_id`) {
        changes[`${prefix}subgroup_id`] = null
      }
    })

    return changes
  }

  onChange(fieldName, options = {}) {
    const booleanValue = this.booleanField(fieldName)

    const change = event => {
      let changes = {}
      let value = event.target.value

      if (booleanValue) {
        value = value.toLowerCase() === "true"
      }

      if (value === "true" || value === "false") {
        value = value === "true"
      }

      if (value === "") {
        value = null
      }

      changes[fieldName] = value
      changes = this.applyTaxonomyChanges(changes, fieldName, value)

      this.setState({ bird: _.merge({}, this.state.bird, changes) })
    }

    return change.bind(this)
  }

  onPlumageVariationChange(pv, options) {
    const valueMap = {
      "true": true,
      "false": false,
      "unknown": null
    }

    var bird = {}

    const change = event => {
      const changes = {
        [pv.id]: valueMap[event.target.value]
      }

      if(options.prefix === "verifier") {
        const verifierPlumageVariations = _.merge(
          {},
          this.state.bird.verifier_plumage_variations,
          changes
        )

        bird = _.merge({}, this.state.bird, {
          verifier_plumage_variations: verifierPlumageVariations,
        })
      } else {
        const plumageVariations = _.merge(
          {},
          this.state.bird.plumage_variations,
          changes
        )

        bird = _.merge({}, this.state.bird, {
          plumage_variations: plumageVariations,
        })
      }

      this.setState({ bird })
    }

    return change.bind(this)
  }

  selectOptions(fieldName) {
    return _.map(this.props.defaults[fieldName], (value) => {
      return (
        <option value={value} key={`bird_${fieldName}_${value}`}>
          {value}
        </option>
      )
    })
  }

  booleanField(fieldName) {
    const keys = _.keys(this.props.defaults[fieldName]).sort()
    return _.isEqual(keys, ['false', 'true'])
  }

  radioButtonOptions(fieldName) {
    const values = this.props.defaults[fieldName]
    const isArray = _.isArray(values)

    let currentValue = this.state.bird[fieldName]

    return (
      <div className="clearfix">
        {_.map(values, (value, keyOrIndex) => {
          const label = value
          let radioValue

          if (isArray) {
            radioValue = value
          } else {
            radioValue = keyOrIndex
          }

          const valueId = radioValue
            .toString()
            .replace(/\s+/, '_')
            .toLowerCase()

          const checkValue = currentValue === null ? "" : currentValue

          const id = `bird_${fieldName}_${valueId}`
          const checked = checkValue.toString() === radioValue.toString()

          return (
            <div className="left" key={id}>
              <input
                value={radioValue}
                type="radio"
                name={`bird[${fieldName}]`}
                id={id}
                onChange={this.onChange(fieldName)}
                checked={checked}
              />

              <label htmlFor={id}>{label}</label>
            </div>
          )
        })}
      </div>
    )
  }

  birdNotIntact() {
    return this.state.bird.intact === false
  }

  headNotMissing() {
    return this.state.bird.head !== false
  }

  feetNotMissing() {
    return this.state.bird.feet !== 'Feet Missing'
  }

  wingsNotMissing() {
    return this.state.bird.wings !== "Wings Missing"
  }

  form() {
    const { bird } = this.state

    return (
      <FullRow>
        <FullRow size="large-2">
          {this.withErrors('bird_number', 'required',
            <label>
              Bird #
              <input
                min="1"
                type="number"
                value={bird.bird_number || ""}
                onChange={this.onChange('bird_number')}
                id="bird_bird_number"
                name="bird[bird_number]"
              />
            </label>
          )}
        </FullRow>

        <fieldset>
          <legend>Bird Characteristics</legend>

          {this.withErrors('where_found', 'required',
            <div>
              <label>Where was the bird found?</label>
              {this.radioButtonOptions('where_found')}
            </div>
          )}

          {this.withErrors('refound', 'required',
            <div>
              <label>Is this a refind?</label>
              {this.radioButtonOptions('refound')}
            </div>
          )}

          {this.withErrors('intact', 'required',
            <div>
              <label>Bird intact?</label>
              {this.radioButtonOptions('intact')}
            </div>
          )}

          {this.birdNotIntact() &&
            <div>
              <div className="head">
                <label>Head</label>
                {this.radioButtonOptions('head')}
              </div>

              <div className="breast">
                <label>Breast</label>
                {this.radioButtonOptions('breast')}
              </div>

              <label className="feet">
                Feet

                <select
                  name="bird[feet]"
                  id="bird_feet"
                  value={bird.feet || ""}
                  onChange={this.onChange('feet')}
                >
                  {this.selectOptions('feet')}
                </select>
              </label>

              {this.withErrors('wings', 'required',
                <label className="wings">
                  Wings

                  <select
                    name="bird[wings]"
                    id="bird_wings"
                    value={bird.wings || ""}
                    onChange={this.onChange('wings')}
                  >
                    {this.selectOptions('wings')}
                  </select>
                </label>
              )}
            </div>
          }

          {this.feetNotMissing() && this.withErrors('foot_condition', 'required',
            <div className="foot-condition">
              <label>Foot condition</label>
              {this.radioButtonOptions('foot_condition')}
            </div>
          )}

          {this.headNotMissing() && this.withErrors('eyes', 'required',
              <div className="eyes">
                <label>Eyes</label>
                {this.radioButtonOptions('eyes')}
              </div>
          )}

          <div className="row">
            {this.headNotMissing() &&
              <div className="columns large-2">
                <label className="bill-length">
                  {this.withErrors('bill_length', null,
                    <div>
                      Bill length (mm)

                      <input
                        min="0"
                        step="1"
                        type="number"
                        value={bird.bill_length || ""}
                        onChange={this.onChange('bill_length')}
                        id="bird_bill_length"
                        name="bird[bill_length]"
                      />
                    </div>
                  )}
                </label>
              </div>
            }

            {this.wingsNotMissing() &&
              <div className="columns large-2 end">
                <label className="wing-length">
                  {this.withErrors('wing_length', null,
                    <div>
                      Wing length (cm)

                      <input
                        min="0"
                        step="0.1"
                        type="number"
                        value={bird.wing_length || ""}
                        onChange={this.onChange('wing_length')}
                        id="bird_wing_length"
                        name="bird[wing_length]"
                      />
                    </div>
                  )}
                </label>
              </div>
            }

            {this.feetNotMissing() &&
              <div className="columns large-2 end">
                <label className="tarsus-length">
                  {this.withErrors('tarsus_length', null,
                    <div>
                      Tarsus length (mm)

                      <input
                        min="0"
                        step="1"
                        type="number"
                        value={bird.tarsus_length || ""}
                        onChange={this.onChange('tarsus_length')}
                        id="bird_tarsus_length"
                        name="bird[tarsus_length]"
                      />
                    </div>
                  )}
                </label>
              </div>
            }
          </div>

          {this.props.isVerifying && this.wingsNotMissing() &&
            <div className="row">
              <div className="columns small-12">
                <label className="molting">
                  {this.withErrors('molting', 'required',
                    <div>
                      <label>Molting</label>
                      {this.radioButtonOptions('molting')}
                    </div>
                  )}
                </label>
              </div>
            </div>
          }

          {this.birdTaxonomy()}
          {this.props.isVerifying && this.birdTaxonomy({ prefix: 'verifier' })}
        </fieldset>

        <fieldset>
          <legend>Bird Characteristics</legend>

          {this.plumageVariations()}
          {!!this.props.isVerifying && this.plumageVariations({ prefix: 'verifier' })}
          {this.cableTies()}

          <fieldset>
            {this.withErrors('tie_location', 'required',
              <div>
                <label>Tag location</label>

                {this.radioButtonOptions('tie_location')}
              </div>
            )}

            {this.withErrors('tie_location_comment', 'required',
              <label>
                Which parts were tagged together? (required if multiple tags)
                <textarea
                  name="bird[tie_location_comment]"
                  id="bird_tie_location_comment"
                  onChange={this.onChange('tie_location_comment')}
                  value={bird.tie_location_comment || "" }
                />
              </label>
            )}
          </fieldset>

          <div className="row">
            <div className="columns large-2">
              {this.withErrors('photo_count', 'required',
                <label>
                  Photo count

                  <input
                    type="number"
                    min="0"
                    name="bird[photo_count]"
                    id="bird_photo_count"
                    value={bird.photo_count || ""}
                    onChange={this.onChange('photo_count')}
                  />
                </label>
              )}
            </div>
          </div>

          {this.withErrors('banded', 'required',
            <div className="bands-or-markers">
              <label>Bands or other scientific markers?</label>
              {this.radioButtonOptions('banded')}
            </div>
          )}

          {this.withErrors('banded_comment', 'required if bird was banded',
            <label>
              Please describe band or other marker and location

              <textarea
                name="bird[banded_comment]"
                id="bird_banded_comment"
                value={bird.banded_comment || ""}
                onChange={this.onChange('banded_comment')}
              />
            </label>
          )}

          {this.withErrors('collected', 'required',
            <div className="bird-collected">
              <label>Was this bird collected?</label>
              {this.radioButtonOptions('collected')}
            </div>
          )}

          {this.withErrors('collected_comment', 'required if bird was collected',
            <label>
              Collected comments (required if collected)

              <textarea
                name="bird[collected_comment]"
                id="bird_collected_comment"
                value={bird.collected_comment || ""}
                onChange={this.onChange('collected_comment')}
              />
            </label>
          )}

          {this.withErrors('oil', 'required',
            <div className="oil-on-body">
              <label>Oil on body?</label>
              {this.radioButtonOptions('oil')}
            </div>
          )}

          {this.withErrors('oil_comment', 'required',
            <label>
              Oil Comments (required if oil on body)

              <textarea
                name="bird[oil_comment]"
                id="bird_oil_comment"
                value={bird.oil_comment || ""}
                onChange={this.onChange('oil_comment')}
              />
            </label>
          )}

          {this.withErrors('entangled', 'required',
            <label>
              If the bird was entangled, please select how below. (We default to "Not")

              <select
                name="bird[entangled]"
                id="bird_entangled"
                value={bird.entangled || ""}
                onChange={this.onChange('entangled')}
              >
                {this.selectOptionsFor('entangled')}
              </select>
            </label>
          )}

          {this.withErrors('entangled_comment', 'required',
            <label>
              Entangled Comments (required if entangled)

              <textarea
                name="bird[entangled_comment]"
                id="bird_entangled_comment"
                value={bird.entangled_comment || ""}
                onChange={this.onChange('entangled_comment')}
              />
            </label>
          )}

          <label>
            Bird comments

            <textarea
              name="bird[comment]"
              id="bird_comment"
              value={bird.comment || ""}
              onChange={this.onChange('comment')}
            />
          </label>

          {this.refindBox()}
          {this.verifierFields()}
        </fieldset>

        {this.formButtons()}
      </FullRow>
    )
  }

  verifierFields() {
    if (!this.props.isVerifying) {
      return null
    }

    const { bird } = this.state

    return (
      <fieldset>
        <legend>Verification</legend>

        {this.withErrors('verification_comment', 'required',
          <label>
            Verifier comments

            <textarea
              name="bird[verification_comment]"
              id="bird_verification_comment"
              value={bird.verification_comment || ""}
              onChange={this.onChange('verification_comment')}
            />
          </label>
        )}

        {this.withErrors('verification_method', 'required',
          <div>
            <label>Verification method</label>
            {this.radioButtonOptions('verification_method')}
          </div>
        )}

        {this.withErrors('identification_level_family', 'required',
          <div>
            <label>Family Identification Level</label>
            {this.radioButtonOptions('identification_level_family')}
          </div>
        )}

        {this.withErrors('identification_level_group', 'required',
          <div>
            <label>Group Identification Level</label>
            {this.radioButtonOptions('identification_level_group')}
          </div>
        )}

        {this.withErrors('identification_level_species', 'required',
          <div>
            <label>Species Identification Level</label>
            {this.radioButtonOptions('identification_level_species')}
          </div>
        )}

        <label>
          Identification Trump

          <textarea
            name="bird[identification_trump]"
            id="bird_identification_trump"
            value={bird.identification_trump || ""}
            onChange={this.onChange('identification_trump')}
          />
        </label>

        {this.withErrors('is_bird', 'required',
          <div>
            <label>Is bird?</label>
            {this.radioButtonOptions('is_bird')}
          </div>
        )}
      </fieldset>
    )
  }

  isRefind() {
    return this.state.bird.refound === true
  }

  refindBox() {
    const { bird } = this.state
    const { refind, survey } = this.props

    if (!this.props.isVerifying) {
      return null
    }

    if (!(this.isRefind() && refind)) {
      return null
    }

    return (
      <fieldset>
        <legend>Refind Information</legend>

        {refind &&
          <div>
            <a
              href={`/surveys/${survey.id}/data/birds/${refind.id}/edit`}
              dangerouslySetInnerHTML={ { __html: refind.display_taxonomy } }
            ></a>

            <p>
              Survey on {refind.survey.survey_date}
            </p>

            <p>{refind.display_plumages}</p>

            <p>Bill: {refind.bill_length}mm</p>
            <p>Wing: {refind.wing_length}cm</p>
            <p>Tarsus: {refind.tarsus_length}mm</p>
          </div>
        }

        {!refind && <p>Refind not found</p>}
      </fieldset>
    )
  }

  selectOptionsFor(fieldName) {
    const values = this.props.defaults[fieldName]

    if (_.isEmpty(values)) {
      return null
    }

    return _.map(values, value => {
      return (
        <option key={`${fieldName}-option-${value}`} value={value}>
          {value}
        </option>
      )
    })
  }

  tieColorOptions() {
    return _.map(TIE_COLORS, (value, key) => {
      value = value === null ? "" : value

      return (
        <option value={value} key={`tie_color_${value}`}>{key}</option>
      )
    })
  }

  cableTies() {
    const { bird } = this.state

    return (
      <fieldset>
        {this.withErrors('tie_number', 'must select at least one tie',
          <legend>Cable Ties</legend>
        )}

        {this.props.isVerifying &&
          <div className="row">
            <div className="columns large-1">
              <label>
                Cable tie number

                <input
                  type="number"
                  min="0"
                  name="bird[tie_number]"
                  id="bird_tie_number"
                  value={bird.tie_number || ""}
                  onChange={this.onChange('tie_number')}
                />
              </label>
            </div>
          </div>
        }

        {!this.props.isVerifying &&
          <div>
            <label>
              Tag color closest to heart

              <select
                name="bird[tie_color_closest]"
                value={bird.tie_color_closest || ""}
                onChange={this.onChange('tie_color_closest')}
                id="bird_tie_color_closest"
              >
                {this.tieColorOptions()}
              </select>
            </label>

            <label>
              Tag color middle

              <select
                name="bird[tie_color_middle]"
                value={bird.tie_color_middle || ""}
                onChange={this.onChange('tie_color_middle')}
                id="bird_tie_color_middle"
              >
                {this.tieColorOptions()}
              </select>
            </label>

            <label>
              Tag color farthest from the heart

              <select
                name="bird[tie_color_farthest]"
                value={bird.tie_color_farthest || ""}
                onChange={this.onChange('tie_color_farthest')}
                id="bird_tie_color_farthest"
              >
                {this.tieColorOptions()}
              </select>
            </label>
          </div>
        }
      </fieldset>
    )
  }

  getSpecies(id) {
    id = parseInt(id, 10)

    return _.find(this.props.taxonomy.species, species => {
      return parseInt(species.id, 10) === id
    })
  }

  getGroup(id) {
    id = parseInt(id, 10)

    return _.find(this.props.taxonomy.groups, group => {
      return parseInt(group.id, 10) === id
    })
  }

  currentSpecies() {
    return this.getSpecies(this.state.bird.species_id)
  }

  currentVerifierSpecies() {
    return this.getSpecies(this.state.bird.verifier_species_id)
  }

  currentGroup() {
    return this.getGroup(this.state.bird.group_id)
  }

  currentVerifierGroup() {
    return this.getGroup(this.state.bird.verifier_group_id)
  }

  currentSpeciesWithVerifierOverride() {
    let currentSpecies = null

    if (this.props.isVerifying) {
      currentSpecies = this.currentVerifierSpecies()
    }

    return currentSpecies || this.currentSpecies()
  }

  plumageVariations(options = {}) {
    const currentSpecies = this.currentSpeciesWithVerifierOverride()

    if ((!this.props.isVerifying) && (!currentSpecies || _.isEmpty(currentSpecies.plumage_ids))) {
      return null
    }

    const prefix = options.prefix || 'volunteer'

    const legend = prefix === 'volunteer' ?
      "Plumage" :
      "Verifier Plumage"

    return (
      <fieldset className={`${prefix}-plumage-variations`}>
        <legend>{legend}</legend>

        {this.plumageVariationOptions(options)}
      </fieldset>
    )
  }

  plumageVariationOptions(options = {}) {
    return _.map(this.props.plumage_variations, variation => {
      return this.plumageVariation(variation, options)
    })
  }

  plumageVariationChecked(pv, value, options) {
    if (options.prefix === 'verifier') {
      return this.state.bird.verifier_plumage_variations[pv.id] === value
    } else {
      return this.state.bird.plumage_variations[pv.id] === value
    }
  }

  plumageVariation(pv, options) {
    const currentSpecies = this.currentSpeciesWithVerifierOverride()

    if (currentSpecies && !this.props.isVerifying && !_.includes(currentSpecies.plumage_ids, pv.id)) {
      return null
    }

    const fieldPrefix = options.prefix === 'verifier' ?
      'verifier_' :
      ''

    const namePrefix = `bird[bird_${fieldPrefix}plumage_variations][${pv.id}]`
    const idPrefix = `bird_${fieldPrefix}plumage_variations_${pv.id}`
    const stateName = `${namePrefix}[state]`

    return (
      <div className={`${options.prefix}-plumage-variation`} key={`bird_pv_${pv.id}`}>
        <input
          type="hidden"
          name={`${namePrefix}[plumage_variation_id]`}
          value={pv.id}
        />

        <input
          type="radio"
          name={stateName}
          id={`${idPrefix}_true`}
          value="true"
          checked={this.plumageVariationChecked(pv, true, options)}
          onChange={this.onPlumageVariationChange(pv, options)}
        />

        <label htmlFor={`${idPrefix}_true`}>{titleize(pv.true_val)}</label>

        <input
          type="radio"
          name={stateName}
          id={`${idPrefix}_false`}
          value="false"
          checked={this.plumageVariationChecked(pv, false, options)}
          onChange={this.onPlumageVariationChange(pv, options)}
        />

        <label htmlFor={`${idPrefix}_false`}>{titleize(pv.false_val)}</label>

        <input
          type="radio"
          name={stateName}
          id={`${idPrefix}_unknown`}
          value="unknown"
          checked={this.plumageVariationChecked(pv, null, options)}
          onChange={this.onPlumageVariationChange(pv, options)}
        />

        <label htmlFor={`${idPrefix}_unknown`}>Unknown</label>
      </div>
    )
  }

  optionCollection(collection) {
    return _.map(collection, item => {
      const key = `collection-option-${item.name}-${item.id}`
      const value = item.id
      let label = item.name

      if (item.description) {
        label += ` (${item.description})`
      }

      return <option key={key} value={value}>{label}</option>
    })
  }

  footTypeFamilies() {
    return this.props.taxonomy.foot_type_families
  }

  getFootTypeFamily(id) {
    id = parseInt(id, 10)

    return _.find(this.footTypeFamilies(), ftf => {
      return parseInt(ftf.id, 10) === id
    })
  }

  isUnknown(taxonomyModel) {
    if (!taxonomyModel) {
      return false
    }

    return Boolean(taxonomyModel.name.match(/^Unknown/))
  }

  isSpeciesUnknown(species) {
    return this.isUnknown(species)
  }

  unknownModel(collection) {
    return _.find(collection, model => this.isUnknown(model))
  }

  species({ fieldPrefix }) {
    const currentFtfId = this.state.bird[`${fieldPrefix}foot_type_family_id`]
    const ftf = this.getFootTypeFamily(currentFtfId)

    if (!ftf || this.isUnknown(ftf)) {
      return []
    }

    const filteredSpecies = _.filter(this.props.taxonomy.species, species => {
      return species.foot_type_family_id.toString() === currentFtfId.toString()
    })

    return _.compact(
      filteredSpecies.concat(
        [this.unknownModel(this.props.taxonomy.species)]
      )
    )
  }

  groups({ fieldPrefix }) {
    const currentFtfId = this.state.bird[`${fieldPrefix}foot_type_family_id`]
    const ftf = this.getFootTypeFamily(currentFtfId)

    if (!ftf || this.isUnknown(ftf)) {
      return []
    }

    const filteredGroups = _.filter(this.props.taxonomy.groups, group => {
      return group.foot_type_family_id.toString() === currentFtfId.toString()
    })

    return _.compact(
      filteredGroups.concat(
        [this.unknownModel(this.props.taxonomy.groups)]
      )
    )
  }

  subgroups({ fieldPrefix }) {
    const currentGroupId = this.state.bird[`${fieldPrefix}group_id`]
    const group = this.getGroup(currentGroupId)

    if (!group || this.isUnknown(group)) {
      return []
    }

    const filteredSubgroups = _.filter(this.props.taxonomy.subgroups, subgroup => {
      return subgroup.group_id.toString() === currentGroupId.toString()
    })

    return _.compact(
      filteredSubgroups.concat(
        [this.unknownModel(this.props.taxonomy.subgroups)]
      )
    )
  }

  birdTaxonomy(options = {}) {
    const { bird } = this.state

    const prefix = options.prefix || 'volunteer'

    const fieldPrefix = prefix === "verifier" ?
      'verifier_' :
      ''

    const legend = prefix === 'volunteer' ?
      "Bird Taxonomy" :
      "Verifier Taxonomy"

    const currentSpecies = prefix === "verifier"
      ? this.currentVerifierSpecies()
      : this.currentSpecies()

    const currentGroup = prefix === "verifier"
      ? this.currentVerifierGroup()
      : this.currentGroup()

    const species = this.species({ fieldPrefix })
    const groups = this.groups({ fieldPrefix })
    const subgroups = this.subgroups({ fieldPrefix })

    const showSpecies = !_.isEmpty(species)
    const showGroups = this.isUnknown(currentSpecies)
    const showSubgroups = Boolean(
      showGroups && currentGroup && !this.isUnknown(currentGroup)
    )

    return (
      <fieldset className={`${prefix}-taxonomy`}>
        <legend>{legend}</legend>

        {this.withErrors(`${fieldPrefix}foot_type_family_id`, 'required',
          <div>
            <label className="foot-type-family">
              Foot Type Family

              <select
                value={bird[`${fieldPrefix}foot_type_family_id`] || ""}
                name={`bird[${fieldPrefix}foot_type_family_id]`}
                id={`bird_${fieldPrefix}foot_type_family_id`}
                onChange={this.onChange(`${fieldPrefix}foot_type_family_id`)}
              >
                <option value=""></option>
                {this.optionCollection(this.footTypeFamilies())}
              </select>
            </label>

            <p>
              Feet Missing? FTF can be found under the Description on species
              pages in <em>Beached Birds</em>.
            </p>
          </div>
        )}

        {showSpecies && this.withErrors(`${fieldPrefix}species_id`, 'required',
          <label className="bird-species">
            Species

            <select
              value={bird[`${fieldPrefix}species_id`] || ""}
              name={`bird[${fieldPrefix}species_id]`}
              id={`bird_${fieldPrefix}species_id`}
              onChange={this.onChange(`${fieldPrefix}species_id`)}
            >
              <option value=""></option>
              {this.optionCollection(species)}
            </select>
          </label>
        )}

        {showGroups && this.withErrors(`${fieldPrefix}group_id`, 'required',
          <label className="bird-group">
            Group

            <select
              value={bird[`${fieldPrefix}group_id`] || ""}
              name={`bird[${fieldPrefix}group_id]`}
              id={`bird_${fieldPrefix}group_id`}
              onChange={this.onChange(`${fieldPrefix}group_id`)}
            >
              <option value=""></option>
              {this.optionCollection(groups)}
            </select>
          </label>
        )}

        {showSubgroups && this.withErrors(`${fieldPrefix}subgroup_id`, 'required',
          <label className="bird-subgroup">
            Subgroup

            <select
              value={bird[`${fieldPrefix}subgroup_id`] || ""}
              name={`bird[${fieldPrefix}subgroup_id]`}
              id={`bird_${fieldPrefix}subgroup_id`}
              onChange={this.onChange(`${fieldPrefix}subgroup_id`)}
            >
              <option value=""></option>
              {this.optionCollection(subgroups)}
            </select>
          </label>
        )}
      </fieldset>
    )
  }

  labelWithErrors(fieldName, message, child) {
    return this.withErrors(
      fieldName,
      message,
      <label>{child}</label>
    )
  }

  partsOutOfRange() {
    const species = this.speciesForRangeCheck()

    if (!species) {
      return []
    }

    if (this.isRefind()) {
      return []
    }

    const partsToCheck = _.compact([
      this.headNotMissing() ? 'bill' : null,
      this.wingsNotMissing() ? 'wing' : null,
      this.feetNotMissing() ? 'tarsus' : null
    ])

    return _.reduce(partsToCheck, (outOfRange, part) => {
      const range = species.ranges[part]
      const currentValue = this.state.bird[`${part}_length`]

      if (!_.inRange(currentValue, range.min, range.max + 1)) {
        outOfRange.push({
          part,
          currentValue,
          range
        })
      }

      return outOfRange
    }, [])
  }

  speciesForRangeCheck() {
    let species = null

    if (this.props.isVerifying) {
      species = this.currentVerifierSpecies()
    }

    species = species || this.currentSpecies()

    return species
  }

  withErrors(fieldName, message, child) {
    const errors = this.state.bird.errors[fieldName]

    if (errors) {
      return (
        <div className="error large-12 columns">
          {child}
          <small className="error">{message || errors}</small>
        </div>
      )
    } else {
      return child
    }
  }

  formButtons() {
    if (!this.props.isEditable) {
      return null
    }

    let saveText = "Save"
    let saveAndContinueText = "Save & Continue"
    const surveyPersisted = Boolean(this.props.survey.id)

    if (this.props.isVerifying) {
      saveText = "Save & Verify"
      saveAndContinueText = "Save, Verify, & Continue"
    }

    return (
      <ul className="button-group right">
        {surveyPersisted &&
          [
            <li key="delete-survey-button">
              <a
                data-confirm="Are you sure?"
                className="button alert"
                rel="nofollow"
                data-method="delete"
                href="/surveys/50233"
              >Delete Survey</a>
            </li>,
            <li key="save-survey-button">
              <button type="submit" className="button">{saveText}</button>
            </li>
          ]
        }

        <li>
          <button
            className="button continue-button"
            type="submit"
            name="continue"
            value="true"
          >
            {saveAndContinueText}
          </button>
        </li>
      </ul>
    )
  }

  warningModal() {
    if (!this.state.showWarningModal) {
      return null
    }

    const outOfRange = this.partsOutOfRange()

    if (_.isEmpty(outOfRange)) {
      return null
    }

    const styles = {
      content: {
        bottom: 'auto'
      }
    }

    return (
      <Modal isOpen={true} style={styles}>
        <div id="bird_part_invalid_modal">
          <p>
            Please confirm you want to submit measurements out of range
          </p>

          <div className="invalid-measurements">
            {_.map(outOfRange, error => {
              const { range } = error

              return (
                <p key={`out-of-range-${error.part}`}>
                  {error.part}: {error.currentValue}{range.unit}
                  <br />
                  <em>(valid range: {range.min} to {range.max}{range.unit})</em>
                </p>
              )
            })}
          </div>

          <button
            className="continue-editing info"
            aria-label="Close"
            onClick={this.closeModal}
          >
            Continue Editing
          </button>

          <button className="ignore-and-submit" onClick={this.forceFormSubmit}>
            Submit Anyway
          </button>
        </div>
      </Modal>
    )
  }

  onSubmit = event => {
    const modalHidden = !this.state.showWarningModal
    const hasPartsOutOfRange = !_.isEmpty(this.partsOutOfRange())

    if (modalHidden && hasPartsOutOfRange) {
      event.preventDefault()
      this.setState({ showWarningModal: true })

      return false
    }

    return true
  }

  forceFormSubmit = event => {
    event.preventDefault()
    this.formRef.submit()
  }

  closeModal = event => {
    event.preventDefault()
    this.setState({ showWarningModal: false })
  }

  render() {
    const { bird } = this.state

    return (
      <div className="c-bird-form">
        {this.warningModal()}

        <FullRow>
          <h3>{this.title()}</h3>
        </FullRow>

        {bird.tie_number &&
          <FullRow>
            <h3>Cable Tie #{bird.tie_number}</h3>
          </FullRow>
        }

        <form
          className={this.formClasses()}
          action={this.props.formUrl}
          acceptCharset="UTF-8"
          method="post"
          onSubmit={this.onSubmit}
          ref={ref => this.formRef = ref}
        >
          <input name="utf8" type="hidden" value="&#x2713;" />
          <input type="hidden" name="authenticity_token" value={csrfToken()} />
          <input type="hidden" name="_method" value={this.props.newRecord ? 'post' : 'put'} />

          {this.form()}
        </form>
      </div>
    )
  }
}

BirdForm.displayName = 'BirdForm'
